import axios from '../config/axios';

/**
 * Expects payload with the existing fields PLUS:
 *  - allowed_type_ids: number[]
 *  - allowed_subtype_ids: number[]
 */
// packages/shared/data/updateSharingSettings.js
import api from '../config/axios'; // your preconfigured axios instance

export default async function updateSharingSettings(token, payload) {
  try {
    const res = await api.put('/me/sharing', payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data; // <-- Axios uses res.data
  } catch (err) {
    // Normalize error message
    const msg =
      err?.response?.data?.message ||
      err?.response?.data ||
      err.message ||
      'Request failed';
    throw new Error(msg);
  }
}
